import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const positionApiUrl = `${baseApiUrl}/api/Positions`;

export async function getPositions() {
  return await httpRequest(fetchPositions.bind(this));
}

async function fetchPositions() {
  let config = getHttpHeaders();
  return await axios.get(`${positionApiUrl}`, config);
}
